"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Type;
(function (Type) {
    Type[Type["\u30CE\u30FC\u30DE\u30EB"] = 0] = "\u30CE\u30FC\u30DE\u30EB";
    Type[Type["\u307B\u306E\u304A"] = 1] = "\u307B\u306E\u304A";
    Type[Type["\u307F\u305A"] = 2] = "\u307F\u305A";
    Type[Type["\u3067\u3093\u304D"] = 3] = "\u3067\u3093\u304D";
    Type[Type["\u304F\u3055"] = 4] = "\u304F\u3055";
    Type[Type["\u3053\u304A\u308A"] = 5] = "\u3053\u304A\u308A";
    Type[Type["\u304B\u304F\u3068\u3046"] = 6] = "\u304B\u304F\u3068\u3046";
    Type[Type["\u3069\u304F"] = 7] = "\u3069\u304F";
    Type[Type["\u3058\u3081\u3093"] = 8] = "\u3058\u3081\u3093";
    Type[Type["\u3072\u3053\u3046"] = 9] = "\u3072\u3053\u3046";
    Type[Type["\u30A8\u30B9\u30D1\u30FC"] = 10] = "\u30A8\u30B9\u30D1\u30FC";
    Type[Type["\u3080\u3057"] = 11] = "\u3080\u3057";
    Type[Type["\u3044\u308F"] = 12] = "\u3044\u308F";
    Type[Type["\u30B4\u30FC\u30B9\u30C8"] = 13] = "\u30B4\u30FC\u30B9\u30C8";
    Type[Type["\u30C9\u30E9\u30B4\u30F3"] = 14] = "\u30C9\u30E9\u30B4\u30F3";
    Type[Type["\u3042\u304F"] = 15] = "\u3042\u304F";
    Type[Type["\u306F\u304C\u306D"] = 16] = "\u306F\u304C\u306D";
    Type[Type["\u30D5\u30A7\u30A2\u30EA\u30FC"] = 17] = "\u30D5\u30A7\u30A2\u30EA\u30FC";
    Type[Type["Normal"] = 0] = "Normal";
    Type[Type["Fire"] = 1] = "Fire";
    Type[Type["Water"] = 2] = "Water";
    Type[Type["Electric"] = 3] = "Electric";
    Type[Type["Grass"] = 4] = "Grass";
    Type[Type["Ice"] = 5] = "Ice";
    Type[Type["Fighting"] = 6] = "Fighting";
    Type[Type["Poison"] = 7] = "Poison";
    Type[Type["Ground"] = 8] = "Ground";
    Type[Type["Flying"] = 9] = "Flying";
    Type[Type["Psychic"] = 10] = "Psychic";
    Type[Type["Bug"] = 11] = "Bug";
    Type[Type["Rock"] = 12] = "Rock";
    Type[Type["Ghost"] = 13] = "Ghost";
    Type[Type["Dragon"] = 14] = "Dragon";
    Type[Type["Dark"] = 15] = "Dark";
    Type[Type["Steel"] = 16] = "Steel";
    Type[Type["Fiary"] = 17] = "Fiary";
})(Type = exports.Type || (exports.Type = {}));
exports.ノーマル = Type.ノーマル;
exports.ほのお = Type.ほのお;
exports.みず = Type.みず;
exports.でんき = Type.でんき;
exports.くさ = Type.くさ;
exports.こおり = Type.こおり;
exports.かくとう = Type.かくとう;
exports.どく = Type.どく;
exports.じめん = Type.じめん;
exports.ひこう = Type.ひこう;
exports.エスパー = Type.エスパー;
exports.むし = Type.むし;
exports.いわ = Type.いわ;
exports.ゴースト = Type.ゴースト;
exports.ドラゴン = Type.ドラゴン;
exports.あく = Type.あく;
exports.はがね = Type.はがね;
exports.フェアリー = Type.フェアリー;
exports.Normal = Type.Normal;
exports.Fire = Type.Fire;
exports.Water = Type.Water;
exports.Electric = Type.Electric;
exports.Grass = Type.Grass;
exports.Ice = Type.Ice;
exports.Fighting = Type.Fighting;
exports.Poison = Type.Poison;
exports.Ground = Type.Ground;
exports.Flying = Type.Flying;
exports.Psychic = Type.Psychic;
exports.Bug = Type.Bug;
exports.Rock = Type.Rock;
exports.Ghost = Type.Ghost;
exports.Dragon = Type.Dragon;
exports.Dark = Type.Dark;
exports.Steel = Type.Steel;
exports.Fiary = Type.Fiary;
